import { CustomTheme } from '@nemuru-eng/js-api-client';

import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const CustomThemeOptions = (t: GetTextIdTranslationType) =>
  Object.values(CustomTheme).map((value) => ({
    value,
    display: t(value.toLowerCase()) || value.toLowerCase(),
  }));
